<!--  龙辉出库确认单据打印模板 -->
<template>
    <div v-loading="loading">
        <div id="printRecContent" class="print-zone">
            <div style="margin:0 auto; width: 763px;">
                <div id="top">
                    <div class="print-title-view">
                        <div v-if="isEditTitle" class="print-title">
                            <el-input type="text" v-model="titleConfig.RValue"></el-input>
                        </div>
                        <div v-else class="print-title">{{ titleConfig.RValue }}</div>
                    </div>
                </div>
                <div id="table">
                    <table border="1" cellspacing="0" cellpadding="1" width="100%" style="border-collapse: collapse;table-layout:fixed;" bordercolor="#333333" id="mtable">
                        <thead>
                            <tr style="text-align:center;font-weight: bold;">
                                <td style="width: 40px;">
                                    <div><b>序号</b></div>
                                </td>
                                <td style="width: 66px;">
                                    <div><b>部门</b></div>
                                </td>
                                <td style="width:181px;">
                                    <div><b>单号</b></div>
                                </td>
                                <td style="width:130px;">
                                    <div><b>客户</b></div>
                                </td>
                                <td style="width: 80px;">
                                    <div><b>支付方式</b></div>
                                </td>
                                <td style="width: 66px;">
                                    <div><b>订单总额</b></div>
                                </td>
                                <td style="width: 60px;">
                                    <div><b>开单人</b></div>
                                </td>
                                <td style="width: 140px;">
                                    <div><b>创建时间</b></div>
                                </td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-bind:key="index" v-for="(AP, index) in dataList">
                                <td style="text-align:center;">{{ Number(index) + 1 }}</td>
                                <td>{{ AP.OrgName }}</td>
                                <td>{{ AP.OrderCode }}</td>
                                <td>{{ AP.EntpCusName }}</td>
                                <td>{{ AP.PayTypeName }}</td>
                                <td style="text-align: right;">
                                    {{ AP.OrderType == 0 ? AP.OrderAmount+AP.ShipAmount - AP.DiscountAmount : -(AP.OrderAmount+AP.ShipAmount - AP.DiscountAmount)
                                    }}&nbsp;
                                </td>
                                <td>{{ AP.SName }}</td>
                                <td>{{ AP.CreateTime }}</td>
                            </tr>
                            <tr style="text-align:center;font-weight: bold;">
                                <td align="right" colspan="4">
                                    <div><b>合计：</b></div>
                                </td>
                                <td colspan="2" align="right">{{ allPrice }}&nbsp;</td>
                                <td></td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="dialog-footer">
            <div class="btn-ctn-left">
                <div class="re-set">
                    <el-button class="btn-primary" @click="isEditTitle = true" v-if="titleConfig == null ? false : titleConfig.Result && !isEditTitle"
                        >编辑标题</el-button
                    >
                    <el-button class="btn-primary" @click="submitTitleConfig()" v-if="isEditTitle">保存标题</el-button>
                </div>
            </div>
            <div class="re-submit">
                <el-button class="btn-primary" @click="lodopPrint" v-if="!isDefaultSet">打印</el-button>
                <el-button class="btn-primary" v-print="'#printRecContent'" v-else>打印</el-button>
                <el-button @click="cancel()">关闭</el-button>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: '',
    components: {},
    props: {
        isInit: {
            default: false,
            type: Boolean
        },
        ordersList: {
            type: Array,
            default: () => {}
        },
        sParams: {
            type: Object
        },
    },
    data() {
        let userMsg = this.$util.getLocalStorage('userMsg');
        return {
            loading: true,
            allPrice: 0,
            allPrice1: 0,
            isDefaultSet: false,
            isPreview: false,
            employeeName: userMsg.EmployeeName,
            printDate: '',
            orderList: [],
            searchParams: {},
            dataList: [],
            company: userMsg.EntpName,
            isEditTitle: false, //编辑标题
            titleConfig: {
                RValue: userMsg.EntpName + '出库确认单'
            } //标题配置
        };
    },
    watch: {},
    created() {},
    mounted() {
        if (this.isInit) {
            this.getConfigByCodes().then(() => {
                this.init();
            });
        } else this.loading = false;
    },
    methods: {
        init() {
            let that = this;
            that.allPrice = 0;
            that.allPrice1 = 0;
            
            if (that.sParams) {
                that.sParams.page = 1;
                that.searchParams = { ...that.sParams };
            } else {
                that.searchParams = {};
            }
            let amount = 0;
            let amount1 = 0;
            that.dataList = [];
            // that.orderList = [...that.ordersList];
            // that.orderList.forEach((e, i) => {
            //     if (e.OrderType == 0) amount += e.OrderAmount;
            //     else amount -= e.OrderAmount;
            //     amount1 += e.BillAmount;
            // });
            // that.allPrice = amount.toFixed(2);
            // that.allPrice1 = amount1.toFixed(2);
            // that.orderLis = that.orderList.sort(function(a, b) {
            //     return new Date(b.CreateTime) - new Date(a.CreateTime);
            // });

            that.getTableData();
        },
        getConfigByCodes() {
            return new Promise(resolve => {
                let codes = ['dyckqrbt', 'syllqdysz', 'dyyl'];
                this.$util.getSysConfigs(codes).then(data => {
                    if (data) {
                        for (let i = 0; i < data.length; i++) {
                            let code = data[i].Code;
                            let result = data[i].Result;
                            switch (code) {
                                case 'dyckqrbt':
                                    this.titleConfig = data[i];
                                    if (!this.titleConfig || !this.titleConfig.RValue) this.titleConfig.RValue = this.company + '出库确认单';
                                    break;
                                case 'syllqdysz':
                                    this.isDefaultSet = result;
                                    break;
                                case 'dyyl': //是否出现预览界面
                                    this.isPreview = result;
                                    break;
                            }
                        }
                    }
                    resolve();
                });
            });
        },
        getTableData() {
            let that = this;
            if (that.searchParams.Keyword) that.searchParams.CusId = '';
            that.$util
                .axiosPost({
                    // url: '/api/RevenueManagement_H/GetCusOrdersConfirmList',
                    url: '/api/RevenueManagement_H/GetCusOrdersConfirmList_New',
                    data: that.searchParams,
                    hideLoading: true
                })
                .then(res => {
                    let data = res.data;
                    if (!data.DataList || data.DataList.length == 0) {
                        that.loading = false;
                        return;
                    } else {
                        // if(that.searchParams.page==1){
                        //     that.searchParams.total = res.count;
                        // }
                        let list = [...that.dataList, ...data.DataList];
                        that.dataList = list;
                        if (that.dataList.length < that.searchParams.total) {
                            that.searchParams.page++;
                            this.getTableData();
                        } else {
                            let amount = 0;
                            let amount1 = 0;
                            that.dataList.forEach((e, i) => {
                                if (e.OrderType == 0) amount += e.OrderAmount + e.ShipAmount - e.DiscountAmount;
                                else amount -= e.OrderAmount + e.ShipAmount - e.DiscountAmount;
                                amount1 += e.BillAmount;
                            });
                            that.allPrice = amount.toFixed(2);
                            that.allPrice1 = amount1.toFixed(2);
                            that.loading = false;
                        }
                    }
                })
                .catch(() => {
                    that.loading = false;
                });
        },
        lodopPrint() {
            let LODOP = this.$lodop.getLodop(); //调用getLodop获取LODOP对象
            if (LODOP) {
                let topStyle = `
                    body{margin: 0 auto;width: 210m;}               
                    .print-title-view {
                        width: 762px;
                        position: relative;
                        display: flex;
                        justify-content: space-between;
                        align-items: flex-end;
                        padding: 20px 0;
                    }

                    .print-title-view .print-title {
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                        max-width: 50%;
                        margin: 0 auto;
                        text-align: center;
                        font-size: 20px;
                        font-weight: bold;
                        color: #000;
                        min-height: 26px;
                    }                 
               `;
                let tableStyle = `
                    #mtable table,
                    #mtable td,
                    #mtable th {
                        border-width: 1px;
                        border-style: solid;
                        border-collapse: collapse;
                        color: #000;
                        padding-bottom: 3px;
                        padding-top: 3px;
                        padding-left: 2px;                        
                    }
                     /* 为了兼容火狐不换行 */
                    #mtable td{
                        word-break: break-all;word-wrap: break-word;
                    }                     
                    #mtable {
                        width: 763px;
                        margin: 0 auto;
                        border-top: solid 1px black;                    
                    }               
                `;
                LODOP.PRINT_INIT('打印出库确认单');
                LODOP.SET_PRINT_STYLEA(0, 'Horient', 2);
                let printContentHeight = document.getElementById('printRecContent').clientHeight;
                //这是签名的横线，因为样式不起作用，所以用来画直线的接口实现
                // LODOP.ADD_PRINT_LINE(bot - 36, 103, bot - 36, 270, 0, 1);
                // LODOP.ADD_PRINT_LINE(bot - 36, 430, bot - 36, 600, 0, 1);

                let topHeight = document.querySelector('#printRecContent #top').clientHeight;
                let tableHeight = document.querySelector('#printRecContent #table').clientHeight;
                let printTableH = 1080 - topHeight;
                let pageFootTop = 1080;
                if (printContentHeight <= 1080) {
                    LODOP.SET_PRINT_PAGESIZE(3, '210mm', '20mm', ''); // 这里3表示纵向打印且纸高“按内容的高度”；580表示纸宽58mm；45表示页底空白4.5mm
                    pageFootTop = printContentHeight;
                    // printTableH = 950;
                }

                LODOP.ADD_PRINT_HTM('0', '0', '100%', '100%', `<style>${topStyle}</style>` + document.querySelector('#printRecContent #top').innerHTML);
                LODOP.ADD_PRINT_TABLE(topHeight, 0, '100%', printTableH, `<style>${tableStyle}</style>` + document.querySelector('#printRecContent #table').innerHTML);
                // LODOP.SET_PRINT_STYLEA(0, 'TableHeightScope', 2); //高度包含页头

                //放在底部会被页尾的内容遮挡
                LODOP.ADD_PRINT_HTM(10, 690, 300, 10, "<font><span tdata='pageNO' format='#'>第#页</span> / <span tdata='pageCount' format='#'>共#页</span></font>");
                LODOP.SET_PRINT_STYLEA(0, 'ItemType', 1);
                LODOP.SET_PRINT_STYLEA(0, 'Horient', 1);

                //选择操作系统中设为“默认”的打印机，“-1”代表默认打印机
                LODOP.SET_PRINTER_INDEX(-1);
                // LODOP.PRINT_DESIGN();

                if (!this.isInit) this.orderList = [];
                if (this.isPreview) LODOP.PREVIEW();
                //预览
                else LODOP.PRINT(); // 直接打印
            }
        },
        // 取消
        cancel() {
            this.$emit('closeDialog');
        },
        //提交打印标题
        submitTitleConfig() {
            this.isEditTitle = false;
            this.$util.setSysConfigValue(this.titleConfig.ConfigId, this.titleConfig.RValue);
        }
    }
};
</script>
<style lang="less" scoped media="print">
.print-zone {
    width: 210mm;
}
.print-title-view {
    width: 100%;
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    padding: 20px 0;
}

.print-title-view .print-title {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    max-width: 50%;
    margin: 0 auto;
    text-align: center;
    font-size: 20px;
    font-weight: bold;
    color: #000;
    min-height: 26px;
}
.print-table-main {
    width: 792px;
    font-size: 14px;
}
.print-table-main .theader {
    text-align: center;
    font-weight: bold;
}
.print-table-main .tcen {
    text-align: center;
}
.print-table-main .tright {
    text-align: right;
    padding-right: 5px;
}
.print-table-main .div-table-cell {
    overflow: hidden;
    word-break: break-all;
    word-wrap: break-word;
    height: auto;
    line-height: 25px;
    padding-left: 1px;
    border-top: 1px solid #000;
    border-right: 1px solid #000;
    border-bottom: 1px solid #000;
    color: #000;
    box-sizing: border-box;
}
.print-table-main .div-table-row {
    border-left: 1px solid #000;
}
.dialog-footer {
    display: -webkit-flex;
    display: flex;
    flex-direction: row;
    // justify-content: right;
    justify-content: space-between;
    margin-top: 20px;
}
.btn-ctn-left {
    display: flex;
}
.re-submit {
    text-align: right;
}
.order-remark {
    display: -webkit-flex;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    color: #000;
    font-weight: bold;
    padding: 5px 0px 5px 0px;
}

#mtable table,
#mtable td,
#mtable th {
    border-width: 1px;
    border-style: solid;
    border-collapse: collapse;
    color: #000;
    padding-bottom: 3px;
    padding-top: 3px;
    padding-left: 2px;
}
</style>
